import _property from 'lodash/property';

var active = _property('active');

var costWithoutSaleWarning = _property('costWithoutSaleWarning');

var createdByUserId = _property('createdByUserId');

var dealerId = _property('dealerId');

var deleted = _property('deleted');

var name = _property('name');

var documentTypeId = _property('documentTypeId');

var franchiseId = _property('franchiseId');

var id = _property('id');

var createdTime = _property('createdTime');

var intercompanyAllowed = _property('intercompanyAllowed');

var journalName = _property('journalName');

var journalNumber = _property('journalNumber');

var journalTypeId = _property('journalTypeId');

var modifiedByUserId = _property('modifiedByUserId');

var modifiedTime = _property('modifiedTime');

var accountControlOverrides = _property('accountControlOverrides');

var accountControlOverrideAllowed = _property('accountControlOverrideAllowed');

var accountControlNumberMandatoryOverrides = _property('accountControlNumberMandatoryOverrides');

var READER = {
  active: active,
  costWithoutSaleWarning: costWithoutSaleWarning,
  createdByUserId: createdByUserId,
  dealerId: dealerId,
  deleted: deleted,
  documentTypeId: documentTypeId,
  franchiseId: franchiseId,
  id: id,
  createdTime: createdTime,
  intercompanyAllowed: intercompanyAllowed,
  journalName: journalName,
  journalNumber: journalNumber,
  journalTypeId: journalTypeId,
  modifiedByUserId: modifiedByUserId,
  modifiedTime: modifiedTime,
  name: name,
  accountControlOverrides: accountControlOverrides,
  accountControlOverrideAllowed: accountControlOverrideAllowed,
  accountControlNumberMandatoryOverrides: accountControlNumberMandatoryOverrides
};
export default READER;